var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-full"},[_c('div',{staticClass:"mx-auto"},_vm._l((_vm.availableColors),function(color){return _c('color-selector',{key:color.id,attrs:{"title":color.color_name,"color":color.hexcode,"active":color.id === _vm.currentColor.id},on:{"click":function($event){return _vm.updateColor(color.id)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }